<template>
  <section id="assist__rule">
    <h2>超额权益</h2>
    <div class="card">
      <div class="card__section" v-for="item in card" :key="item.title">
        <div class="card__title">{{ item.title }}</div>
        <div class="card__desc" v-if="!item.course" v-html="item.desc"></div>
        <div class="card__flex" v-else>
          <div class="left">
            <span>{{ item.amount }}</span>
            <sup>{{ item.unit }}</sup>
          </div>
          <div class="right">
            <h5>{{ item.course }}</h5>
            <h6>{{ item.desc }}</h6>
          </div>
        </div>
      </div>
    </div>
    <div v-if="btnType && btnType === 'reward'">
      <div class="btn-secondary" @click="toReward">
        <i class="anyteachicon anyteach-gift" />
        <span>我的直播课奖励</span>
      </div>
      <router-link tag="div" to="/assist/video" class="btn-link">我的视频课奖励</router-link>
    </div>
    <div v-if="btnType && btnType === 'start'">
      <router-link tag="div" class="btn-secondary" to="/assist/rule">
        <i class="anyteachicon anyteach-zhulihuodong" />
        <span>发起助力</span>
      </router-link>
    </div>
  </section>
</template>

<script>
import Toast from "mand-mobile/lib-vw/toast"
export default {
  name: "AssistRule",
  props: ["btnType", "selectedRule"],
  data() {
    return {
      card: [
        {
          title: "每邀请 1 位助力，发起人获得",
          amount: 3,
          unit: "天",
          course: "趣蒙直播课",
          desc: "欧美外教真人直播，30000 位妈妈的选择",
        },
        {
          title: "好友获得",
          amount: 3,
          unit: "集",
          course: "趣蒙视频课",
          desc: "基于朗文 Supertots，配备精英名师授课",
        },
        {
          title: "邀请 10 人，自动升级城市合伙人",
          desc:
            "获得 30 天直播课之余加入 10000 名 AnyTeach 合伙人<br/>每单高达 ¥200 或 30 天直播课的邀请奖励<br/>现金直接转入微信零钱",
        },
      ],
    }
  },
  methods: {
    toReward() {
      if (this.$route.path === "/assist/rule" && !this.$store.state.user.mobile) {
        return this.$emit("phone")
      }

      if (!this.selectedRule && this.$route.path === "/assist/rule") {
        Toast({
          content: "还未参与活动，请先选择奖励",
          position: "bottom",
        })
        return this.$emit("choose")
      }
      this.$router.push("/assist/reward")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

#assist__rule {
  text-align: center;
  p {
    @include body();
  }
}
</style>
